//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    haslinks: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
